<template>
	<div class='matters-wrap'>
		<div class="nav-wrap">
			<div class="flex">
				<i class="iconfont icon-home1"></i>
				<router-link class="link" to="/server/administrat_find">行政许可/行政处罚查询</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link class="link" to="/mattersDirectory" replace><span>事项目录</span></router-link>
			</div>
		</div>
		<div class="flex flex-wrap matters-main">
			<router-link class="flex flex-row-center" tag="a" target="_blank" :to="`/mattersDetail?name=${item.fullName}&id=${item.id}`" v-for="item in list" :key="item.id">
				<span>{{item.fullName}}</span>
			</router-link>
		</div>
	</div>
</template>

<script>
import { getOrganization } from '@/api'
export default {
	components: {},
	data() {
		return {
			list: []
		}
	},
	created() { },
	mounted() {
		this.getList()
	},
	methods: {
		getList() {
			getOrganization().then(res => {
				this.$set(this, 'list', res)
			})
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.matters-wrap {
		padding-bottom: 20px;
		& > .matters-main {
			width: 1280px;
			margin: 0 auto;
			padding-top: 20px;
			& > a {
				width: 15%;
				text-align: center;
				border-radius: 13px;
				border: 1px solid #d01c0b;
				color: #d01c0b;
				white-space: normal;
				height: 50px;
				margin: 0 15px 15px 0;
				& > span {
					line-height: 25px;
				}
			}
		}
	}
</style>